import { render } from "./PendingClinicReview.vue?vue&type=template&id=4febfd1b&scoped=true&lang=pug"
import script from "./PendingClinicReview.vue?vue&type=script&lang=js"
export * from "./PendingClinicReview.vue?vue&type=script&lang=js"

import "./PendingClinicReview.vue?vue&type=style&index=0&id=4febfd1b&scoped=true&lang=scss"
import "./PendingClinicReview.vue?vue&type=style&index=1&id=4febfd1b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4febfd1b"]])

export default __exports__